import { Route } from '@angular/router';

/** Reports and ledger views (read-heavy / analytics). */
export const reportsChildren: Route[] = [
  // purchase-report: used by DB navigation (navigation-structure-data.json)
  {
    path: 'purchase-report',
    loadChildren: () =>
      import('app/modules/Reports/Reports/Reports/reports-routing.module').then(
        (m) => m.PurchaseListReportRoutingModule,
      ),
  },
  {
    path: 'cash-ledger',
    loadChildren: () =>
      import('app/modules/Reports/cash-ledger/cash-ledger-routing.module').then(
        (m) => m.CashLedgerRoutingModule,
      ),
  },
  {
    path: 'batch-reports',
    loadComponent: () =>
      import(
        'app/modules/Reports/Reports/Reports/batch-reports/batch-reports.component'
      ).then(
        (m) => m.BatchReportsComponent,
      ),
  },
  {
    path: 'reports',
    loadChildren: () =>
      import(
        'app/modules/Reports/enterprise-reports/enterprise-reports.routes'
      ).then(
        (m) => m.ENTERPRISE_REPORTS_ROUTES,
      ),
    data: { permission: 'reports' },
  },
];
